import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { PropType, ref, watch } from "vue";

import { Decimal } from "@/libs/decimal";
import { AETERNITY_SYMBOL } from "@/utils/constants";

import FiatPriceFormatter from "@/components/Common/Pricing/FiatPriceFormatter.vue";
import SymbolPriceFormatter from "@/components/Common/Pricing/SymbolPriceFormatter.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceFormatter',
  props: {
  aePrice: {
    type: Object as PropType<Decimal>,
    required: true,
  },
  fiatPrice: {
    type: Object as PropType<Decimal>,
    required: true,
  },
  symbol: {
    type: String,
    default: AETERNITY_SYMBOL,
  },
  watchPrice: {
    type: Boolean,
    default: true,
  },
  watchKey: String,
  priceLoading: Boolean,
  hideFiatPrice: Boolean,
  hideSymbol: Boolean,
  unstyled: Boolean,
  row: Boolean,
},
  setup(__props) {

const props = __props;

const priceJustIncreased = ref(false);
const priceJustDecreased = ref(false);

watch(
  () => [props.aePrice, props.watchKey],
  ([value, watchKey], [prev, prevWatchKey]) => {
    if (watchKey !== prevWatchKey) return;
    if (!value || !prev || !props.watchPrice) return;
    if (value.gte(prev)) {
      priceJustIncreased.value = true;
      setTimeout(() => {
        priceJustIncreased.value = false;
      }, 500);
    } else {
      priceJustDecreased.value = true;
      setTimeout(() => {
        priceJustDecreased.value = false;
      }, 500);
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["price-formatter", {
      unstyled: __props.unstyled,
      'text-red': priceJustDecreased.value,
      'text-green': priceJustIncreased.value,
      'd-flex align-center ga-1': __props.row,
    }])
  }, [
    _createVNode(SymbolPriceFormatter, _mergeProps({ class: "price d-flex align-center" }, _ctx.$attrs, {
      "ae-price": __props.aePrice,
      "hide-symbol": __props.hideSymbol,
      "price-loading": __props.priceLoading,
      "price-just-increased": priceJustIncreased.value,
      "price-just-decreased": priceJustDecreased.value,
      symbol: __props.symbol
    }), null, 16, ["ae-price", "hide-symbol", "price-loading", "price-just-increased", "price-just-decreased", "symbol"]),
    (!__props.hideFiatPrice)
      ? (_openBlock(), _createBlock(FiatPriceFormatter, _mergeProps({
          key: 0,
          class: ['fiat d-flex align-center ga-1', { 'justify-end': __props.row }]
        }, _ctx.$attrs, { "fiat-price": __props.fiatPrice }), null, 16, ["class", "fiat-price"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})